import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import {Box, Button, Tooltip} from "@mui/material";
import {CheckBoxOutlineBlank, CheckBoxOutlined} from "@mui/icons-material";

export function FieldTableSelectorColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);
    useEffect(() => {
        context.registerType({
            dataType: 'selector',
            width: () => '24px',
            className: () => 'column-centered column-button',
            noSort: true,
            noExport:true,
            readOnly:true,
            renderViewer: (props: FieldRendererProps<any,any>) => {
                return (<Button size="small" className="uneditable" onClick={() => props.toggleSelected?.()} >{props.isSelected?<CheckBoxOutlined/>:<CheckBoxOutlineBlank/>}</Button>);
            },
            renderHeader: (props: FieldRendererProps<any,any>) => {
                return <Tooltip title="Toggle All"><Button size="small" onClick={() => props.toggleSelectAll?.()} className="uneditable">{props.isSelectedAll ? <CheckBoxOutlined/>:<CheckBoxOutlineBlank/>}</Button></Tooltip>
            }
        });
    }, [context]);
    return null;
}
